import { useAppDispatch } from 'store'
import { useCurrentConnectorName } from 'store/settings/hooks'
import { useRestoreZkexConnection } from '../../hooks/useRestoreZkexConnection'

export default function Updater() {
  const dispatch = useAppDispatch()
  const currentConnectorName = useCurrentConnectorName()

  // Restore zkex connection from cache
  useRestoreZkexConnection()

  return null
}
